import { styled } from "@mui/material";

const FONT_FAMILY = "'Roboto', sans-serif";

export const StyledErrorBanner = styled("div")`
  display: flex;
  align-items: flex-start;
  gap: 16px;
  font-family: ${FONT_FAMILY};
  background-color: ${({ theme }) => theme.palette.grey[100]};
  border-radius: 8px;
  padding: 16px;
  margin-top: 16px;
  border: 1px solid ${({ theme }) => theme.palette.grey[200]};
`;

export const StyledErrorIconWrapper = styled("div")`
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 12px;
  flex-shrink: 0;
`;

export const StyledErrorContent = styled("div")`
  display: flex;
  flex-direction: column;
  gap: 6px;
  flex: 1;
  min-width: 0;
`;

export const StyledErrorMessage = styled("span")`
  font-family: ${FONT_FAMILY};
  font-size: 13px;
  font-weight: 400;
  color: ${({ theme }) => theme.palette.grey[600]};
  line-height: 1.5;
  word-break: break-word;
`;

export const StyledErrorBadgeWrapper = styled("div")`
  margin-top: 10px;
`;
